<div class="panel-options-body overflow-wrapper theme-setting-panel">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-10">
                <div class="col-xs-12 device-toggle-wrapper">
                    <sp-device-toggle
                        [isDesktop]="isDesktopMode()"
                        [isTablet]="isTabletMode()"
                        [isMobile]="isMobileMode()"
                        (changeDeviceMode)="onChangeDeviceMode($event)"
                    />

                    <sp-synchronize-style-toggle [active]="syncWithDesktop()" (click)="toggleSyncWithDesktop()" />
                </div>
            </div>

            @for (fontField of fontsForm; track tagOf(fontField)) {
                @if (!HIDDEN_FONT_TAGS.includes(tagOf(fontField))) {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ FONT_TAG_TRANSLATIONS[tagOf(fontField)] | translate }}
                        </label>
                        @if (showSharedSettings()) {
                            <div class="col-xs-6 mb-10">
                                <select class="form-control" (change)="setFontFamily(fontField, $event)">
                                    @for (opt of FONT_FAMILY_LIST; track opt) {
                                        <option
                                            [value]="opt"
                                            [style.font-family]="FONT_FAMILIES[opt].name"
                                            [selected]="familyOf(fontField) === opt"
                                        >
                                            {{ FONT_FAMILIES[opt].name }}
                                        </option>
                                    }
                                </select>
                            </div>
                            <div class="col-xs-6 mb-10">
                                <select class="form-control" (change)="setFontWeight(fontField, $event)">
                                    @for (opt of FONT_FAMILIES[familyOf(fontField)].weights; track opt) {
                                        <option
                                            [value]="FONT_WEIGHT_VALUES[opt]"
                                            [selected]="
                                                +valueOf(fontField, themeFontProperties.fontWeight) ===
                                                    FONT_WEIGHT_VALUES[opt] ||
                                                valueOf(fontField, themeFontProperties.fontWeight) === opt
                                            "
                                        >
                                            {{ FONT_WEIGHT_TRANSLATIONS[opt] | translate }}
                                        </option>
                                    }
                                </select>
                            </div>
                        }
                        <div class="col-xs-6 mb-10">
                            <sp-input-num
                                suffixText="px"
                                [min]="FONT_SIZE_MIN"
                                [max]="FONT_SIZE_MAX"
                                [value]="valueOf(fontField, themeFontProperties.fontSize)"
                                (valueChange)="setFontSize(fontField, $event)"
                            />
                        </div>
                        <div class="col-xs-6 mb-10">
                            <div class="btn-group btn-group-justified" data-toggle="buttons">
                                <label
                                    class="btn btn-grey"
                                    [class.active]="
                                        valueOf(fontField, themeFontProperties.textTransform) === 'uppercase'
                                    "
                                    (click)="toggleTextTransform(fontField)"
                                >
                                    <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                                </label>
                                <label
                                    class="btn btn-grey"
                                    [class.active]="valueOf(fontField, themeFontProperties.fontStyle) === 'italic'"
                                    (click)="toggleFontStyle(fontField)"
                                >
                                    <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                                </label>
                            </div>
                        </div>
                        <div class="col-xs-6 mb-10">
                            <sp-input-num
                                prefixImgUrl="./assets/img/lpc-icon-line-height.svg"
                                suffixText="%"
                                [min]="LINE_HEIGHT_MIN"
                                [max]="LINE_HEIGHT_MAX"
                                [value]="valueOf(fontField, themeFontProperties.lineHeight)"
                                (valueChange)="setLineHeight(fontField, $event)"
                            />
                        </div>
                        <div class="col-xs-6 mb-10">
                            <sp-input-num
                                prefixImgUrl="./assets/img/lpc-icon-letter-spacing.svg"
                                suffixText="px"
                                [min]="LETTER_SPACING_MIN"
                                [max]="LETTER_SPACING_MAX"
                                [value]="valueOf(fontField, themeFontProperties.letterSpacing)"
                                (valueChange)="setLetterSpacing(fontField, $event)"
                            />
                        </div>
                        @if (tagOf(fontField) !== BUTTON_TAG) {
                            <div class="col-xs-12 mb-10 font-color-row">
                                <label class="font-color-label">{{ "theme_settings_font_color" | translate }}</label>
                                <sp-color-picker-v2
                                    [hideGradient]="true"
                                    [color]="colorOf(fontField)"
                                    [colorsPreset]="selectedColors()"
                                    (colorChangeEvent)="setColor(fontField, $event)"
                                />
                            </div>
                        } @else {
                            <div class="col-xs-12">
                                <p class="small text-muted font-color-hint">
                                    <span class="sp-icon icon-info-bold color-light small font-color-hint-icon"></span>
                                    {{ "theme_settings_font_button_color_hint" | translate }}
                                </p>
                            </div>
                        }
                    </div>
                }
            }
        </div>
    </div>
</div>

<div class="panel-options-footer">
    <button type="button" class="btn btn-default mr-10" (click)="onCancel()">{{ "cancel" | translate }}</button>
    <button type="button" class="btn btn-success" (click)="onSave()">{{ "save" | translate }}</button>
</div>
